import { GetDisneyPlusDetails } from './../configs/entity.config';
import { Injectable } from '@angular/core';
import { EntityManager } from '@proximus/entity-manager';

@Injectable({
  providedIn: 'root',
})
export class SmoothAccessService {
  constructor() {}

  getDisneyPlusDetails(payload: any) {
    return EntityManager.getEntity(GetDisneyPlusDetails, {
      token: payload.token,
    });
  }
}
